import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13.533 15.028a4.988 4.988 0 0 1 -1.533 -1.028a5 5 0 0 0 -7 0v-9a5 5 0 0 1 7 0a5 5 0 0 0 7 0v8.5","key":"svg-0"}],["path",{"d":"M5 21v-7","key":"svg-1"}],["path",{"d":"M22 22l-5 -5","key":"svg-2"}],["path",{"d":"M17 22l5 -5","key":"svg-3"}]]

const IconFlagX = createReactComponent('outline', 'flag-x', 'FlagX', __iconNode);

export default IconFlagX;